import { initLogin } from './login/data/sagas';
import Login from './login/entry';
import { initRegistrationPage } from './register/data/sagas';
import Registration from './register/entry';
import ResetPassword from './resetPassword/entry';
import { initSetPassword } from './setPassword/data/sagas';
import SetPassword from './setPassword/entry';
import ConfirmationPage from './signUp/confirmationPage/entry';
import { initSignUpPage } from './signUp/data/sagas';
import SecurityPage from './signUp/securityPage/entry';
import SignUpPage from './signUp/signUpPage/entry';
import SSOLogin from './sso/entry';
import TwoFactorAuthentication from './twoFactorAuthentication/TwoFactorAuthentication';
import { redirectIfLoggedIn } from './twoFactorAuthentication/data/sagas';

export default [
  {
    exact: true,
    path: '/login/sso',
    component: SSOLogin,
  },
  {
    exact: true,
    path: '/login',
    component: Login,
    saga: initLogin,
  },
  {
    exact: true,
    path: '/reset_password',
    component: ResetPassword,
  },
  {
    exact: true,
    path: '/register',
    component: Registration,
    saga: initRegistrationPage,
  },
  {
    exact: true,
    path: '/set_password/:token',
    component: SetPassword,
    saga: initSetPassword,
  },
  {
    exact: true,
    path: '/authenticate',
    component: TwoFactorAuthentication,
    saga: redirectIfLoggedIn,
  },
  {
    exact: true,
    path: '/signup',
    name: 'signup',
    component: SignUpPage,
    saga: initSignUpPage,
  },
  {
    exact: true,
    path: '/confirmation',
    name: 'confirmation',
    component: ConfirmationPage,
    saga: null,
  },
  {
    exact: true,
    path: '/security',
    name: 'security',
    component: SecurityPage,
    saga: null,
  },
];
